import React, {Component} from "react";
import {Link} from "react-router-dom";
import {UrlListButton} from "../UrlListButton";
import {AssignBusinessUnitLabelsButton} from "../AssignBusinessUnitLabelsButton";
import {BusinessUnitSyncAlertIcon} from "../BusinessUnitSyncAlertTooltip";
import {SnoozeAllAlertsButton} from "../SnoozeAllAlertsButton";
import {BusinessUnitAdAccountGeneralAlertIcon} from "../BuccGeneralAlertTooltip";
import {BusinessUnitShowAdAccountsOrCampaignsTooltip} from "../BusinessUnitShowAdAccountsOrCampaignsTooltip";
import {ANALYTICS_CHANNEL, CHANNEL_INFO_BY_CHANNEL, CHANNEL_TYPE_PAID_MEDIA, CHANNEL_TYPE_ECOMMERCE, CHANNEL_TYPE_ANALYTICS} from "../../channels/channels";

export class BusinessUnitNameCell extends Component {
    constructor(props) {
        super(props);
        this.state = {
            counter: 0
        };

        this.doRender = this.doRender.bind(this);
    }

    doRender() {
        this.setState({'counter': this.state.counter+1});
    }

    getChannelClassName() {
        if (this.props.channels.length === 1) {
            return ("bu-cell -" + this.props.channels[0].toLowerCase())
        } else {
            // Separar canales publicitarios/ecommerce de Analytics
            const nonAnalyticsChannels = this.props.channels.filter(channel => {
                const channelInfo = CHANNEL_INFO_BY_CHANNEL[channel];
                return channelInfo && 
                       (channelInfo.channelType === CHANNEL_TYPE_PAID_MEDIA || 
                        channelInfo.channelType === CHANNEL_TYPE_ECOMMERCE);
            });
            
            const analyticsChannels = this.props.channels.filter(channel => {
                const channelInfo = CHANNEL_INFO_BY_CHANNEL[channel];
                return channelInfo && channelInfo.channelType === CHANNEL_TYPE_ANALYTICS;
            });
            
            // Si hay solo un canal publicitario/ecommerce + Analytics, usar clase con dos barras
            if (nonAnalyticsChannels.length === 1 && analyticsChannels.length === 1 && this.props.channels.length === 2) {
                const nonAnalyticsChannel = nonAnalyticsChannels[0].toLowerCase();
                return ("bu-cell -" + nonAnalyticsChannel + "-analytics")
            } else {
                // Si hay múltiples canales publicitarios/ecommerce + Analytics, mostrar violeta con Analytics
                if (nonAnalyticsChannels.length > 1 && analyticsChannels.length === 1) {
                    return ("bu-cell -mixed-analytics")
                } else {
                    // El violeta solo para cuando hay múltiples canales publicitarios/ecommerce sin Analytics
                    return ("bu-cell -mixed")
                }
            }
        }
    }

    render() {
        return (
            <td>
                <div className={this.getChannelClassName()}>
                    <div className="bu-name-with-tooltip">
                        <div className="bu-name">
                            <Link className="table-link"
                                  to={`/client/${this.props.clientId}/`}>{this.props.clientName}</Link>
                            |
                            <Link className="table-link"
                                  to={`/business-unit/${this.props.businessUnitId}/`}>{this.props.businessUnitName}</Link>
                        </div>
                        <div className="bu-tooltip">
                            <p className="tooltip-description">
                                {this._ad_account_detailed_name()}
                            </p>
                        </div>
                    </div>
                    <div className="some-icons">
                        {this.renderRowIcons()}
                    </div>
                </div>
            </td>
        );
    }

    renderRowIcons() {
        return [
            this.renderToggleDetails(),
            this.renderGeneralAlerts(),
            this.renderUrls(),
            this.renderLabels(),
            this.renderSnoozeButton(),
            this.renderSyncAlert()
        ]
    }

    renderToggleDetails() {
        // const tooltipMessage = !this.props.hasAdAccountsDataToShow ? "Hay una sola cuenta publicitaria configurada en el presupuesto." : null;
        const tooltipMessage = null;

        return <BusinessUnitShowAdAccountsOrCampaignsTooltip key="bu-show-ad-accounts-icon"
                                                             message={tooltipMessage}
                                                             onClick={this.props.onAdAccountsDataToggle}
                                                             // enabled={this.props.hasAdAccountsDataToShow}
                                                             enabled={true}
                                                             isShowing={this.props.AdAccountsRowsExpanded}
        />
    }

    renderSnoozeButton() {
        return (
            <SnoozeAllAlertsButton key="bu-snooze-button"
                                   businessUnitId={this.props.businessUnitId}
                                   businessUnitName={this.props.businessUnitName}
                                   clientName={this.props.clientName}
                                   hasAlert={this.props.hasDownUrls}
                                   channel={this.props.channel}
                                   downUrlsCount={this.props.downUrlsCount}
                                   isSnoozed={this.props.isSnoozed}
                                   onSnooze={this.props.onSnoozeAllAlerts}
                                   onStopSnooze={this.props.onStopSnoozeForAllAlerts}
            />
        );
    }

    renderUrls() {
        return (
            <UrlListButton key="url-list"
                           businessUnitAdAccountId={null}
                           businessUnitId={this.props.businessUnitId}
                           title={this._getBusinessUnitCompleteName()}
                           downUrlsCount={this.props.downUrlsCount}
                           hasUrls={this.props.hasUrls}
                           location={this.props.location}
            />
        );
    }

    renderLabels() {
        return (
            <AssignBusinessUnitLabelsButton key="business-unit-labels"
                                            businessUnitName={this.props.businessUnitName}
                                            businessUnitLabels={this.props.businessUnitLabels}
                                            businessUnitId={this.props.businessUnitId}
                                            onLabelsChange={this.props.onLabelsChange}
            />
        );
    }

    renderSyncAlert() {
        if (this.props.syncInformation !== null) {
            return (
                <BusinessUnitSyncAlertIcon key="bu-sync-icon"
                                           isBeingSyncedOnDemand={this.props.syncInformation.is_being_synced_on_demand}
                                           isOnSync={this.props.syncInformation.is_on_sync}
                                           hasSyncProblems={this.props.syncInformation.has_sync_problems}
                                           message={this.syncAlertMessage()}
                                           onClick={this.props.onBusinessUnitSync}
                />
            );
        } else {
            return null;
        }
    }

    renderGeneralAlerts() {
        if (this.props.generalAlerts !== null) {
            return (
                <BusinessUnitAdAccountGeneralAlertIcon key="no-impressions-icon"
                                                       hasNoAccessAlert={this.props.generalAlerts.has_no_access_alert}
                                                       hasImpresionAlert={this.props.generalAlerts.has_no_impression_alert}
                                                       hasCampaignsNotAssignedAlert={this.props.generalAlerts.has_campaigns_not_assigned_alert}
                                                       hasCampaignsNotAssignedAlertSnoozed={this.props.generalAlerts.has_campaigns_not_assigned_alert_snoozed}
                                                       businessUnitId={this.props.businessUnitId}
                                                       doParentReReder={this.doRender}

                />
            );
        } else {
            return null;
        }
    }

    // helpers

    syncAlertMessage() {
        if (this.props.syncInformation !== null && !this.props.syncInformation.is_being_synced_on_demand) {
            return this.syncInformationMessage();
        } else if (this.props.syncInformation !== null && this.props.syncInformation.is_being_synced_on_demand) {
            return 'Sincronizando ...'
        }
    }

    syncInformationMessage() {
        const lastSync = (this.props.syncInformation.last_sync ? this.props.syncInformation.last_sync : "Nunca");
        return `Última sincronización: ${lastSync}.`;
    }

    _getBusinessUnitCompleteName() {
        return `${this.props.clientName} | ${this.props.businessUnitName}`
    }

    _ad_account_detailed_name() {
        return `${this._getBusinessUnitCompleteName()} | ${this._adAccountInfo()}`
    }

    _adAccountInfo() {
        return this.props.adAccountsData.map((businessUnitAdAccountData) => (`${businessUnitAdAccountData['name']} [${businessUnitAdAccountData['account_id']}]`)).join(" - ")
    }
}
